// extracted by mini-css-extract-plugin
export default {"container":"AlbumForm_container__Kk601","footer":"AlbumForm_footer__yeRnJ","clear":"AlbumForm_clear__-LVCF","create":"AlbumForm_create__+sTJp"};